<section class="selected-order-wrapper">
  <div class="trademark-watched">
    <b>{{ trademarkName }}</b>
    <span class="dateShared">{{ dateShared }}</span>
  </div>
  <div class="references-and-region">
    @if (clientReference) {
    <span class="reference">{{ clientReference }}</span>
    } @if (clientReference) {
    <mat-divider vertical></mat-divider>
    }
    <span class="region">{{ regions }}</span>
  </div>
  <div class="classes">{{ classes }}</div>
</section>
